
import axios from '@/load_axios';
import { API_HOST } from '@/constants';

const posts = {
    namespaced: true,
    state: {
        all: [],
    },
    getters: {
        all: (state) => (limit) => {
            let posts = []
            for(let post of state.all) {
                if(posts.length >= limit) {
                    break
                }
                posts.push(post)
            }
            return posts
        },
        id: (state) => (id) => {
            return state.all.find( post => post.id == id)
        },
        slug: (state) => (slug) => {
            return state.all.find( post => post.slug == slug)
        },
    },
    mutations: {
        add(state, posts) {
            for(let post of posts) {
                const index = state.all.findIndex( storedPost => storedPost.id === post.id)
                if(index === -1) {
                    state.all.push(post)
                } else {
                    state.all.splice(index, 1, post)
                }
            }
        },
        addOne(state, post) {
            const index = state.all.findIndex( storedPost => storedPost.id === post.id)
            if(index === -1) {
                state.all.push(post)
            } else {
                state.all.splice(index, 1, post)
            }
        },
    },
    actions: {
        async getAll({commit}) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/video`)
            console.log(res)
            commit('add', res.data)
        },
        async getOne({commit}, id) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/video/${id}`)
            commit('addOne', res.data)
            return res.data
        },
        async getBySlug({commit}, slug) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/video`, {params: {slug}})
            commit('add', res.data)
            return res.data
        },
        async get({commit}, params) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/video`, params )
            commit('add', res.data)
            return res.data
        },
    },
}

export default posts
